import React, { useEffect, useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Input, Modal } from "antd";
import { createUsers } from "../../../redux/SettingModule/UsersPage/UsersAction";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";

interface CreateUsersModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function CreateUsersModal(props: CreateUsersModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [error, setError] = React.useState<string>("");
  const loading = useSelector((state: RootState) => state.UsersPageState.createUsersLoading);

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };
  useEffect(() => {
    return () => {
      setError("");
      form.resetFields();
    };
  }, [props.openState]);
  const CreateUsersModalContent = useMemo(() => {
    const onFinish = async (value: any) => {
      try {
        await dispatch(createUsers(value)).unwrap();
        props.close();
        form.resetFields();
      } catch (error: any) {
        const errorMessage = error.response?.data?.detailedMessages[0];
        setError(errorMessage ? errorMessage : "An error occurred while creating the user. Please try again.");
      }
    };

    return (
      <div style={{ width: "100%" }}>
        <h4>Create User</h4>
        <Form
          form={form}
          colon={false}
          name="createOrganizationForm"
          layout="horizontal"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}>
          <Form.Item
            className="form-item"
            label="First Name"
            name="firstName"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide First Name.",
              },
            ]}
            style={{ marginTop: "25px" }}>
            <Input />
          </Form.Item>

          <Form.Item
            className="form-item"
            label="Last Name"
            name="lastName"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide Last Name.",
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            className="form-item"
            label="User Name"
            name="userName"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide Username.",
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            className="form-item"
            label="Email"
            name="emailAddress"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide email.",
              },
              {
                type: "email",
                message: "Please provide a valid email address.",
              },
            ]}>
            <Input />
          </Form.Item>
          {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}
          <div className="d-flex gap-3 justify-content-end">
            <Button
              htmlType="reset"
              loading={loading}
              onClick={handleModalClose}>
              Cancel
            </Button>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit">
              Create
            </Button>
          </div>
        </Form>
      </div>
    );
  }, [error, loading]);

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={500}
        onCancel={handleModalClose}
        open={props.openState}>
        {CreateUsersModalContent}
      </Modal>
    </div>
  );
}

export default CreateUsersModal;
